/**
 * @flow
 */

import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import type { Node } from 'react'

type Props = {
  children: Node,
}

function ScrollToTop({ children }: Props) {
  const location = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location]) // Trigger the effect when location changes

  return children
}

export default ScrollToTop
